
import {
    defineComponent,
    onMounted,
    ref,
    toRaw
} from "vue";
import ListManager from "@/components/cigo-admin-core/pages/template/ListManager.vue";
import EditCancer from "@/pages/edit/EditCancer.vue";
import cigoLayer from "@/components/cigo-layer";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
import ImportExcelData from "@/components/cigo-ui/unit/other/ImportExcelData.vue";
import {
    convertGroupSheetData,
    convertSampleData
} from "@/home/utils/data";
import {
    apiErrorCatch,
    apiRequest,
    apiSign
} from "@/common/http";
import {
    isNumber
} from "lodash";
import {
    is_numeric
} from "locutus/php/var";

import TipProgress from "@/components/cigo-ui/unit/other/TipProgress.vue";

export default defineComponent({
    name: "CancerMg",
    components: {
        ListManager,
        CigoIconFont,
        TipProgress
    },
    setup(props) {
        const columns = [{
                title: "编号",
                dataIndex: "id",
                width: "80px"
            },
            {
                title: "癌症名称",
                dataIndex: "name",
                width: "200px"
            },
            {
                title: "创建时间",
                dataIndex: "create_time",
                width: "180px"
            }
        ];

        /**
         * 导入分组数据
         */
        const importGroup = (event: any, record: any) => {
            importData(
                "导入分组数据",
                record,
                (sheetData: any, resolve: any, reject: any) => {
                    let layerIndex = cigoLayer.loading("分组数据上传中...");
                    //发起请求添加数据
                    let param = {
                        id: record.id
                    };
                    let sign = apiSign(param);
                    Object.assign(param, {
                        groups: convertGroupSheetData(sheetData)
                    });
                    apiRequest.v1
                        .post("/add/Groups", param, {
                            headers: sign
                        })
                        .then(response => {
                            cigoLayer.close(layerIndex);
                            cigoLayer.msg(response.data.msg);
                            setTimeout(() => {
                                resolve();
                            }, 1000);
                        })
                        .catch(apiErrorCatch.v1);
                }
            );
        };

        /**
         * 导入基因数据
         */
        const importGens = (event: any, record: any) => {
            importData(
                "导入基因数据",
                record,
                (sheetData: any, resolve: any, reject: any) => {
                    let gens = convertSampleData("gens", sheetData);
                    cigoLayer.prompt({
                        layerData: {
                            title: "输入每批次数据条数"
                        },
                        ok: (perNum: string) => {
                            if (!is_numeric(perNum)) {
                                cigoLayer.msg("请输入数字");
                                return true;
                            }

                            tips.value = ["Gens数据导入开始："];
                            percent.value = 0;
                            uploadSampleData(
                                record,
                                gens.length,
                                gens,
                                "add/Gens",
                                resolve,
                                1,
                                Number(perNum),
                                showProgress("基因数据导入进度")
                            );
                        }
                    });
                }
            );
        };

        /**
         * 导入miRNA数据
         */
        const importMiRna = (event: any, record: any) => {
            importData(
                "导入miRNA数据",
                record,
                (sheetData: any, resolve: any, reject: any) => {
                    let miRna = convertSampleData("miRna", sheetData);
                    cigoLayer.prompt({
                        layerData: {
                            title: "输入每批次数据条数"
                        },
                        ok: (perNum: string) => {
                            if (!is_numeric(perNum)) {
                                cigoLayer.msg("请输入数字");
                                return true;
                            }

                            tips.value = ["miRna数据导入开始："];
                            percent.value = 0;
                            uploadSampleData(
                                record,
                                miRna.length,
                                miRna,
                                "add/miRna",
                                resolve,
                                1,
                                Number(perNum),
                                showProgress("miRNA数据导入进度")
                            );
                        }
                    });
                }
            );
        };

        const uploadSampleData = (
            record: any,
            allNum: number,
            dataList: any[],
            path: string,
            resolve: any,
            roundNum: number,
            perNum: number,
            layerIndex: number
        ) => {
            //检查数据量
            if (dataList.length == 0) {
                percent.value = 100;
                tips.value = ["所有数据导入完毕。", "·", "·", ...tips.value];
                cigoLayer.msg("数据导入完毕");
                setTimeout(() => {
                    resolve();

                    cigoLayer.close(layerIndex);
                }, 2000);
                return;
            }

            //提示进度
            tips.value = [
                "第" + roundNum + "批数据导入-开始",
                "·",
                ...tips.value
            ];

            //发起请求添加数据
            let param = {
                id: record.id
            };
            let sign = apiSign(param);
            Object.assign(param, {
                dataList: dataList.splice(0, perNum)
            });

            apiRequest.v1
                .post(path, param, {
                    headers: sign
                })
                .then(response => {
                    percent.value =
                        Math.round(
                            (100 - (dataList.length / allNum) * 100) * 100
                        ) / 100;
                    tips.value = [
                        "第" + roundNum + "批数据导入-完毕",
                        ...tips.value
                    ];

                    //上传下一批数据
                    uploadSampleData(
                        record,
                        allNum,
                        dataList,
                        path,
                        resolve,
                        roundNum + 1,
                        perNum,
                        layerIndex
                    );
                })
                .catch(apiErrorCatch.v1);
        };

        const importData = (title: string, record: any, callFunc: any) => {
            cigoLayer.component({
                component: ImportExcelData,
                width: "1000px",
                height: "900px",
                maskClose: false,
                layerData: {
                    title: title,
                    autoColumns: true,
                    tableScroll: {
                        x: 150000
                    }
                },
                notify: (
                    flag: string,
                    sheetData ? : any,
                    resolve ? : any,
                    reject ? : any
                ) => {
                    if (flag !== "ok") {
                        return;
                    }
                    //TODO 增加加载中动画
                    callFunc(sheetData, resolve, reject);
                }
            });
        };

        let tips: any = ref([]);
        let percent = ref(0);
        const showProgress = (title: string) => {
            return cigoLayer.component({
                component: TipProgress,
                width: "500px",
                height: "600px",
                canDrag: false,
                maskClose: false,
                showCtrlBar: false,
                layerData: {
                    title: title,
                    percent: percent,
                    tips: tips
                }
            });
        };

        return {
            columns,
            EditCancer,
            importGroup,
            importGens,
            importMiRna
        };
    }
});
